<template>
  <div v-if="show">
    <div class="modal olympic-modal letter fade show" style="display: block;" tabindex="-1" role="dialog">
      <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <div class="title-with-icon">
              <div class="title-with-icon__icon title-with-icon__icon_login"></div>
              <div class="title-with-icon__title">
                <span class="title-letter">Начало олимпиады</span>
              </div>
            </div>
            <button type="button" class="close modal-close" @click="$emit('close')" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="olympics-slider">
              <div class="slider-container">
                <div class="slide-content">
                  <div class="slide-image">
                    <img :src="slides[currentSlide].image" :alt="slides[currentSlide].title" />
                  </div>
                  <div class="slide-text">
                    <h3>{{ slides[currentSlide].title }}</h3>
                    <p class="slide-description">{{ slides[currentSlide].content }}</p>
                  </div>
                </div>
                
                <!-- Навигация слайдера -->
                <div class="slider-navigation">
                  <button 
                    @click="prevSlide" 
                    :disabled="currentSlide === 0"
                    class="btn btn-outline-secondary btn-sm"
                  >
                    ← Назад
                  </button>
                  
                  <div class="slider-dots">
                    <span 
                      v-for="(slide, index) in slides" 
                      :key="index"
                      :class="{ active: currentSlide === index }"
                      class="dot"
                      @click="currentSlide = index"
                    ></span>
                  </div>
                  
                  <button 
                    v-if="currentSlide < slides.length - 1"
                    @click="nextSlide" 
                    class="btn btn-primary btn-sm"
                  >
                    Далее →
                  </button>
                  <button 
                    v-else
                    @click="handleBegin" 
                    class="btn btn-primary"
                  >
                    Начать олимпиаду
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-backdrop show"></div>
  </div>
</template>

<script>
export default {
  name: 'OlympicsStartModal',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    slides: {
      type: Array,
      default: () => []
    }
  },
  emits: ['close', 'begin'],
  data() {
    return {
      currentSlide: 0
    }
  },
  watch: {
    show(newVal) {
      if (newVal) {
        this.currentSlide = 0
      }
    }
  },
  methods: {
    nextSlide() {
      if (this.currentSlide < this.slides.length - 1) {
        this.currentSlide++
      }
    },
    prevSlide() {
      if (this.currentSlide > 0) {
        this.currentSlide--
      }
    },
    handleBegin() {
      this.$emit('begin')
    }
  }
}
</script>

<style scoped>
.olympics-slider {
  padding: 2rem 0;
}

.slider-container {
  text-align: center;
}

.slide-content {
  margin-bottom: 2rem;
}

.slide-image {
  margin-bottom: 1.5rem;
}

.slide-image img {
  max-width: 200px;
  height: auto;
  border-radius: 8px;
}

.slide-text h3 {
  color: #002E5E;
  font-size: 2.4rem;
  font-weight: 700;
  margin-bottom: 1rem;
}

.slide-description {
  font-size: 1.6rem;
  line-height: 2.4rem;
  color: #333;
  white-space: pre-line;
}

.slider-navigation {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 2rem;
}

.slider-dots {
  display: flex;
  gap: 0.8rem;
  justify-content: center;
}

.dot {
  width: 1.2rem;
  height: 1.2rem;
  border-radius: 50%;
  background-color: #E0E0E0;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.dot.active {
  background-color: #ED1B2F;
}

.dot:hover {
  background-color: #BDBDBD;
}

@media (max-width: 768px) {
  .slider-navigation {
    flex-direction: column;
    gap: 1.5rem;
  }
  
  .slide-image img {
    max-width: 150px;
  }
  
  .slide-text h3 {
    font-size: 2rem;
  }
  
  .slide-description {
    font-size: 1.4rem;
  }
}
</style>
